import globalLogger from '../../logger';

const logger = globalLogger.createChannel('recompose.helper');

// NOTE: Reimplementation of recompose's createHelper as it wasn't exposed :(
const createHelper = (func, helperName, setDisplayName = true, noArgs = false) => {
    if (process.env.NODE_ENV !== 'production' && setDisplayName) {
        const { wrapDisplayName } = require('../../../node_module_clones/recompose');

        if (noArgs) {
            return (BaseComponent) => {
                const Component = func(BaseComponent);
                Component.displayName = wrapDisplayName(BaseComponent, helperName);
                return Component;
            };
        }

        return (...args) => {
            if (args.length > func.length) {
                // Not called correctly. It should be called like: `${helperName}(...args)(BaseComponent)`
                logger.error('Failed to apply helper (too many arguments)', {
                    helperName,
                    passedArgCount: args.length,
                    expectedMax: func.length,
                });
            }

            return (BaseComponent) => {
                const Component = func(...args)(BaseComponent);
                Component.displayName = wrapDisplayName(BaseComponent, helperName);
                return Component;
            };
        };
    }

    return func;
};

export default createHelper;
